import { Flex, Text } from "rebass";
import styled from "styled-components";
import { DynamicNextLink } from "./dynamic-next-link";

// crumbs: {link, title: string}[]
// link: { internal: boolean, href, as }
const Breadcrumbs = ({ crumbs }) => {
  return (
    <Text as={Flex} color="white" fontSize={[0, 0, 1]} fontFamily="medium">
      {crumbs.map((breadcrumb, index) => (
        <Text
          as="span"
          key={index}
        >
          <S_DynamicNextLink link={breadcrumb.link}>
            {breadcrumb.title}
          </S_DynamicNextLink>
        </Text>
      ))}
    </Text>
  );
};

const S_DynamicNextLink = styled(DynamicNextLink)`
  &:after {
    content: ${props => (props.link !== undefined ? '"  /  "' : '""')};
    white-space: pre;
  }

  a:hover {
    text-decoration: underline;
  }
`;

export { Breadcrumbs };
